export default __webpack_public_path__ + "static/2167-b60ffc2c8569d605ba03966099673bf9.gif";